import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "emc_install_dismissed";

// "Install Aplikasi" banner. Captures the browser's beforeinstallprompt so we
// can offer an in-app Add-to-Home-Screen button. Hidden when the app already
// runs standalone or the user dismissed it.
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const standalone =
    typeof window !== "undefined" &&
    (window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone);

  if (!deferred || dismissed || standalone) return null;

  const close = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* ignore */ }
  };

  const install = async () => {
    try {
      deferred.prompt();
      await deferred.userChoice;
    } catch { /* ignore */ }
    setDeferred(null);
  };

  return (
    <div
      data-testid="install-prompt"
      className="fixed inset-x-0 bottom-[4.75rem] z-40 px-3 lg:bottom-4 lg:left-auto lg:right-4 lg:w-80 lg:px-0"
    >
      <div className="flex items-center gap-3 rounded-2xl border border-slate-700 bg-slate-900 px-4 py-3 shadow-2xl">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#F6EE23] text-slate-900">
          <Download size={18} />
        </span>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-white leading-tight">Install Aplikasi</div>
          <div className="text-[11px] text-slate-400 leading-tight">Pasang di layar utama seperti aplikasi.</div>
        </div>
        <button
          type="button"
          onClick={install}
          data-testid="install-prompt-accept"
          className="shrink-0 rounded-lg bg-[#F6EE23] px-3 py-2 text-xs font-bold text-slate-900 transition active:scale-95"
        >
          Install
        </button>
        <button
          type="button"
          onClick={close}
          data-testid="install-prompt-dismiss"
          aria-label="Tutup"
          className="shrink-0 rounded-md p-1 text-slate-400 hover:text-white"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
